<template>
  <GDialog :width="width" :height="height" :scrollable="scrollable">
    <div class="modal__body" :class="{ 'modal__body-with-scroll': scrollable }">
      <!-- modal header -->
      <div class="modal__body-head" :class="margin">
        <!-- в компонент можно менять только этот тайтл -->
        <slot name="header" />
        <p v-html="title"></p>
        <IconComponent @click="$emit('close')" :name="themeLigth ? 'closeCross' : 'closeClean'" />
      </div>
      <!-- modal body -->
      <div class="modal__body-inner-wrap">
        <!-- slot start -->
        <slot />
        <!-- slot end -->
      </div>
    </div>
  </GDialog>
</template>

<script>
  import IconComponent from '@/common/ui/IconComponent.vue';

  export default {
    name: 'ModalComponent',
    components: { IconComponent },
    props: {
      title: {
        default: '',
        type: String,
      },
      width: {
        type: Number,
        default: 610,
      },
      height: {
        type: String,
      },
      themeLigth: {
        type: Boolean,
        default: false,
      },
      // чтобы был визуальный скролл, передать true
      scrollable: {
        type: Boolean,
        default: false,
      },
      // классы, которые находятся в style, для переопределения отступа между заголовком и текстом
      margin: {
        type: String,
        validator: (value) => ['mb-8'].includes(value),
      },
    },
  };
</script>

<style lang="scss" scoped>
  .modal {
    &__body {
      height: 100%;
      padding: 32px 40px;
      background: #ffffff;

      @media (max-width: $mobile) {
        padding: 16px;
      }

      &-head {
        display: flex;
        justify-content: space-between;
        margin-bottom: 24px;

        p {
          font: $fira-24;
          font-weight: 500;
        }

        .icon {
          cursor: pointer;
          color: #787f8f;
        }
      }

      &-inner-wrap {
        height: 100%;
      }

      &-with-scroll {
        padding: 16px 6px 16px 16px;
        width: 100%;
        display: flex;
        flex-direction: column;
      }
    }

    &--new & {
      &__body {
        padding: 0 40px 40px;
        max-height: 90dvh;
        overflow: auto;

        &-head {
          position: sticky;
          top: 0;
          background: #fff;
          z-index: 1;
          padding: 40px 0 4px;
          margin-bottom: 20px;

          p {
            font-weight: normal;
            text-transform: none;
            font: $fira-24-M;
            letter-spacing: 0;
          }
        }

        &-inner-wrap {
          position: relative;
          z-index: 0;
        }
      }

      @media (max-width: $laptop) {
        &__body {
          padding: 0 14px 14px;
          max-height: 100dvh;

          &-head {
            margin-bottom: 12px;
            padding-top: 14px;

            p {
              font: $fira-20-M;
            }
          }
        }
      }
    }

    &--edit-subtask & {
      @media (max-width: $mobile-2) {
        &__body {
          &-head {
            p {
              font-size: 19px;
            }
          }
        }
      }
    }
  }
</style>
